import React from 'react';
export function TypingIndicator() {
  return <div className="flex items-start mb-3" data-id="element-384">
      <div className="bg-yeppy-white border border-yeppy-text border-opacity-10 rounded-yeppy rounded-bl-none px-4 py-3 max-w-[85%]" data-id="element-385">
        <div className="flex items-center space-x-1" data-id="element-386">
          <div className="w-2 h-2 bg-yeppy-text bg-opacity-50 rounded-full animate-bounce" style={{
          animationDelay: '0ms',
          animationDuration: '1.4s'
        }} data-id="element-387" />
          <div className="w-2 h-2 bg-yeppy-text bg-opacity-50 rounded-full animate-bounce" style={{
          animationDelay: '200ms',
          animationDuration: '1.4s'
        }} data-id="element-388" />
          <div className="w-2 h-2 bg-yeppy-text bg-opacity-50 rounded-full animate-bounce" style={{
          animationDelay: '400ms',
          animationDuration: '1.4s'
        }} data-id="element-389" />
        </div>
      </div>
    </div>;
}